export const userProfile = require("../assets/user-profile.png");
export const bsLogo = require('../assets/bharat_stage_logo.png');
export const topBgImg = require('../assets/group_.png');
export const leftImg = require('../assets/img1.png');
export const rightImg = require('../assets/img2.png');
export const secondImg = require('../assets/img3.png');
export const profileImg = require('../assets/portfolio_img.png');
export const msgIcon = require('../assets/msgIcon.png');
export const bellIcon = require('../assets/bellIcon.png');
export const footerBG = require('../assets/footer_bg_img.png');
export const facebookIcon = require('../assets/facebook_icon.png');
export const instagramIcon = require('../assets/instagram_icon.png');
export const xIcon = require('../assets/x_icon.png');

